import { BaseURl } from "./BaseApiUrl";



//https://testcockpit.p2k.in/api/userdetails/getUserPendingSystemCallBoardsRecords/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&callType=2&isPagination=1&pageNo=1&perPageRec=200&recordsDate=2026-02-12
export const getUserPendingLiveStickCallsAPIURL = BaseURl + "userdetails/getUserPendingLiveStickyCallBoardsRecords/v1/";

//https://testcockpit.p2k.in/api/userdetails/getActiveUsersList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&isPagination=1&pageNo=1&perPageRec=2
export const getActiveUserListAPIURL = BaseURl + "userdetails/getUsersListForRouteStickyLivePendingCalls/v1/";


//https://testcockpit.p2k.in/api/UserDetails/routeUserSysCalls/v1/
export const routeUserLiveStickyCallsAPIURL = BaseURl + "userDetails/routeUserLiveStickyCalls/v1/";